<mat-card class="table-card">
  <mat-card-header class="table-card-header">
    <mat-card-title i18n="component tableau bots | titre">Bots</mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <app-table-bots [bots]="result?.data"></app-table-bots>
  </mat-card-content>
  <mat-divider></mat-divider>
  <mat-card-footer class="table-card-footer">
    <mat-card-actions align="end">
      <app-table-paginator
        [pageNumber]="result?.page"
        [hasNextPage]="result?.hasNextPage"
        (pageChange)="onPageChange($event)"
      ></app-table-paginator>
    </mat-card-actions>
  </mat-card-footer>
</mat-card>
